module.exports = __webpack_public_path__ + "static/media/yuntaishan_package.3e544869.webp";